import React from 'react';
import styled from 'styled-components';
import { modsyHeartLogoClicked } from 'web-ui-kit/events';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;

var STYLE_VARIANTS = {
  "default": {
    width: '20px',
    useLink: true
  },
  messengerProfilePic: {
    width: '16px',
    useLink: false
  },
  messengerAvatar: {
    width: '28px',
    useLink: false
  },
  messengerAvatarSmall: {
    width: '15px',
    useLink: false
  },
  avatarLarge: {
    width: '40px',
    useLink: false
  }
};

function ModsyHeart(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? function (_ref2) {
    var children = _ref2.children;
    return (
      /*#__PURE__*/
      React.createElement("a", null, children)
    );
  } : _ref$linkComponent,
      _ref$modsyButtonConfi = _ref.modsyButtonConfig,
      modsyButtonConfig = _ref$modsyButtonConfi === void 0 ? {
    destination: '/',
    app: 'web-post-purchase'
  } : _ref$modsyButtonConfi;
  var styleVariant = variant ? STYLE_VARIANTS[variant] : STYLE_VARIANTS["default"];
  var LinkComponent = styleVariant.useLink ? linkComponent : NoLink;
  var calculatedWidth = styleVariant.width;
  return (
    /*#__PURE__*/
    React.createElement(LinkComponent, {
      route: modsyButtonConfig,
      styledLink: StyledLink
    },
    /*#__PURE__*/
    React.createElement("svg", {
      role: "img",
      "aria-labelledby": "modsy-heart-title modsy-heart-desc",
      onClick: function onClick(event) {
        return dispatch({
          type: modsyHeartLogoClicked,
          payload: {
            event: event
          }
        });
      },
      width: calculatedWidth,
      style: {
        cursor: 'pointer',
        margin: margin
      },
      viewBox: "0 0 51 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    /*#__PURE__*/
    React.createElement("title", {
      id: "modsy-heart-title"
    }, "Go to modsy homepage"),
    /*#__PURE__*/
    React.createElement("desc", {
      id: "modsy-heart-desc"
    }, "Heart logo to redirect to modsy homepage"),
    /*#__PURE__*/
    React.createElement("rect", {
      width: calculatedWidth,
      height: calculatedWidth,
      fill: "url(#pattern0)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M25.026 12.2677V24.3399L37.5389 12.1998V0.127686L25.026 12.2677Z",
      fill: "#ECBC13"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M37.5391 0.127686V12.1998L43.8091 18.2829L50.0519 12.2677L37.5391 0.127686Z",
      fill: "#415B82"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M50.0517 12.2675L25.026 36.396V48.4681L50.0517 24.3396V24.3343V12.2675Z",
      fill: "#698CCF"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M25.0259 12.2677V24.3399L12.5131 12.1998V0.127686L25.0259 12.2677Z",
      fill: "#0E7065"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.5129 0.128113V12.2002L6.2428 18.2833L0 12.2682L12.5129 0.128113Z",
      fill: "#EB9494"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M0 12.2675L25.0257 36.396V48.4681L0 24.3396V24.3343V12.2675Z",
      fill: "#A84C58"
    })))
  );
}

var NoLink = function NoLink(_ref3) {
  var children = _ref3.children;
  return (
    /*#__PURE__*/
    React.createElement(NoLinkVariation, null, children)
  );
};

var NoLinkVariation = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: fit-content;\n"])));
var StyledLink = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export default ModsyHeart;